"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _appConfigHelper = require("../../util/appConfigHelper");
var _ThankYouPageStyled = require("../ThankYouPage/ThankYouPageStyled");
var _ThankYouPage = require("./ThankYouPage.styled");
var _jsxRuntime = require("react/jsx-runtime");
var CheckmarkIcon = function CheckmarkIcon(props) {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        fill: "red",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M93.648 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M99.956 5.464h-1.572a.762.762 0 0 1-.762-.762.762.762 0 0 1 .762-.762h1.572a.762.762 0 0 1 .762.762.762.762 0 0 1-.762.762z"
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M96.016 3.096a.761.761 0 0 1-.762-.762V.762A.761.761 0 0 1 96.016 0a.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M96.016 9.405a.761.761 0 0 1-.762-.762V7.07a.761.761 0 0 1 .762-.762.762.762 0 0 1 .762.762v1.572a.762.762 0 0 1-.762.762z"
                  })
                })]
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
              children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "m4.437 65.45-1.111-1.112a.762.762 0 0 1 0-1.078.762.762 0 0 1 1.077 0l1.112 1.112a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.078 0z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "m8.898 69.91-1.112-1.112a.762.762 0 0 1 0-1.077.762.762 0 0 1 1.078 0l1.111 1.111a.762.762 0 0 1 0 1.078.762.762 0 0 1-1.077 0z"
                  })
                })]
              }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
                children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M7.784 65.45a.762.762 0 0 1 0-1.077l1.111-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L8.861 65.45a.762.762 0 0 1-1.077 0z"
                  })
                }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
                  children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
                    fill: "#bcc3cd",
                    d: "M3.323 69.91a.762.762 0 0 1 0-1.077l1.112-1.112a.762.762 0 0 1 1.078 0 .762.762 0 0 1 0 1.078L4.4 69.911a.762.762 0 0 1-1.078 0z"
                  })
                })]
              })]
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            stroke: "#838eaa",
            fill: "none",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "3",
              cy: "8.838",
              cx: "9.471"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "2.5",
              cy: "8.838",
              cx: "9.471"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
            stroke: "#838eaa",
            fill: "none",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "3",
              cy: "62.838",
              cx: "96.471"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
              r: "2.5",
              cy: "62.838",
              cx: "96.471"
            })]
          })]
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: "#4eb7a1",
            d: "M71.684 20.127a1.733 1.733 0 0 0-2.451 0l-20.8 20.743-7.5-8.15a1.734 1.734 0 1 0-2.551 2.349l8.726 9.477a1.732 1.732 0 0 0 1.238.559h.037a1.735 1.735 0 0 0 1.224-.506l22.075-22.018a1.733 1.733 0 0 0 .002-2.454z"
          })
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
            fill: "#4eb7a1",
            d: "M71.266 35.104a1.734 1.734 0 0 0-1.733 1.734A19.533 19.533 0 1 1 50 17.305a1.734 1.734 0 1 0 0-3.467 23 23 0 1 0 23 23 1.734 1.734 0 0 0-1.734-1.734z"
          })
        })
      })]
    })]
  });
};
CheckmarkIcon.defaultProps = {
  width: "100.718",
  height: "73.237",
  xmlns: "http://www.w3.org/2000/svg",
  color: "red"
};
const ThankYouPage = () => {
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ThankYouPage.ThankYouPageStyled, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(CheckmarkIcon, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPage.HeaderStyled, {
      children: t('redeem-gift.thank-you-page.header', 'Thank You!')
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ThankYouPage.InfoTextStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
        children: t('redeem-gift.thank-you-page.manage-text1', 'Your gift have been successfully redeemed.')
      }), t('redeem-gift.thank-you-page.payment-method-text', 'We hope you love it. Remember that in order to keep your access after your gift expires, you will need to add a payment method to your account.'), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPage.InfoTextWrapper, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_reactI18next.Trans, {
          i18nKey: "redeem-gift.thank-you-page.manage-text2",
          children: ["If you need help from us with your account, you can always find it", /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPageStyled.LinkStyled, {
            href: (0, _appConfigHelper.getData)('CLEENG_MY_ACCOUNT_URL'),
            target: "_blank",
            rel: "noopener noreferrer",
            children: "here."
          })]
        })
      })]
    })]
  });
};
var _default = exports.default = ThankYouPage;